import { type FC } from 'react';

import { MainGameBalance } from './MainGameBalance';

const RollBalance: FC = () => {
  return (
    <div className="w-full px-10 flex gap-3 -translate-y-1/2">
      <MainGameBalance className="flex-1" type="dice" />
      <MainGameBalance className="flex-1" type="energy" />
    </div>
  );
};

export { RollBalance };
